export const VEHICLE_LOCATION_TAG = 'VEHICLE_LOCATION';
export const EVENTS_TAG = 'EVENTS';
export const EVENTS_DETAILS_TAG = 'EVENTS_DETAILS';
export const CAR_DESTINATIONS_TAG = 'CAR_DESTINATIONS';
export const CAR_PARK_TAG = 'CAR_PARK';
export const HIGHWAY_TAG = 'HIGHWAY';
export const LOCATION_DETAILS_TAG = 'LOCATION_DETAILS';
export const RENTAL_CAR_DRIVER_TAG = 'RENTAL_CAR_DRIVER';
export const RENTAL_CAR_DRIVER_UPDATE_TAG = 'RENTAL_CAR_DRIVER_UPDATE';
export const RENTAL_CAR_INFORMATION_TAG = 'RENTAL_CAR_INFORMATION';
